/**
 * Illinois Tech Graduate College Career Outcomes data.
 *
 * DATA PROVENANCE: these numbers come from a PDF export of
 * https://elevate.iit.edu/graduates-outcomes/ (Class of 2025, Graduate
 * College, First Destination survey - 90% response rate), supplied directly
 * by the user, not scraped. See src/data/iit-outcomes.json for the source
 * values, and scripts/scrape-iit-outcomes.md for how to refresh this data.
 *
 * Note: Illinois Tech publishes a *ranked* top-employers list (1-20), not a
 * hire count per employer - topEmployers is a string list, not a quantity.
 *
 * In this Vite build the JSON is imported statically at build time (no
 * server-side fetch needed, unlike the previous Next.js version).
 */
import raw from '../data/iit-outcomes.json';

export type EmploymentOutcome = {
  status: string;
  percent: number;
};

export type CountryPlacement = {
  country: string;
  percent: number;
};

export type SalarySummary = {
  mean: number;
  median: number;
  note: string;
};

export interface IitOutcomesData {
  sourceUrl: string;
  classYear: string;
  sourceNote?: string;
  employment: EmploymentOutcome[];
  salarySummary: SalarySummary | null;
  topEmployers: string[];
  topEmployersNote?: string;
  placementsByCountry: CountryPlacement[];
}

const SOURCE_URL = 'https://elevate.iit.edu/graduates-outcomes/';

export const outcomesData: IitOutcomesData = {
  sourceUrl: SOURCE_URL,
  classYear: raw.classYear,
  sourceNote: raw.sourceNote,
  employment: raw.employment,
  salarySummary: raw.salarySummary ?? null,
  topEmployers: raw.topEmployers ?? [],
  topEmployersNote: raw.topEmployersNote,
  placementsByCountry: raw.placementsByCountry ?? [],
};
